import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';

const useStyles = createUseStyles({
  container: {},
  tabs: {},
  tabsStretch: {
    display: 'flex',
  },
  tab: {
    margin: 0,
    padding: '16px 42px',
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'uppercase',
    border: 0,
    color: '#6D819C',
    outline: 'none',
    borderBottom: '2px solid',
    borderBottomColor: 'rgba(255, 255, 255, 0)',
    transition: '0.2s',
    cursor: 'pointer',
    background: 'none',
    touchAction: 'manipulation',
  },
  tabActive: {
    color: '#FF5E3A',
    borderBottomColor: '#FF5E3A',
  },
  tabStretch: {
    flex: 1,
    paddingRight: 0,
    paddingLeft: 0,
  },
  content: {
    color: '#000',
  },
});

type Props = {
  tabs: { id: string; title: string }[];
  activeTabId: string;
  onClick: (id: string) => void;
  children: React.ReactNode;
  stretch: boolean;
};

const Tabs = (props: Props) => {
  const { tabs, activeTabId, onClick, children, stretch } = props;
  const classes = useStyles();
  const tabsStyle = cx({
    [classes.tabs]: true,
    [classes.tabsStretch]: stretch,
  });

  return (
    <div className={classes.container}>
      <div className={tabsStyle}>
        {tabs.map(({ id, title }, i) => (
          <button
            key={id}
            onClick={() => onClick(id)}
            className={cx({
              [classes.tab]: true,
              [classes.tabActive]:
                id === activeTabId || (i === 0 && !activeTabId),
              [classes.tabStretch]: stretch,
            })}
          >
            {title}
          </button>
        ))}
      </div>
      {children && <div className={classes.content}>{children}</div>}
    </div>
  );
};

export default Tabs;
